import { memo } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@elfsight/widget-modal';
import { useSettings } from '@wu/widget-core';
import { TitleTooltip } from './common';

function LogoComponentInner({ data, customColor = true, height }) {
  const { captionType, logoColor } = useSettings();
  const { caption, file } = data;
  const { url, alt } = file?.data ?? {};
  const disabledTooltip = captionType !== 'hover' || caption === '';

  return (
    <Tooltip title={<TitleTooltip text={caption} />} disabled={disabledTooltip}>
      <Image
        src={url}
        alt={alt ?? ''}
        onDragStart={(e) => e.preventDefault()}
        tabIndex={alt ? 0 : undefined}
        _height={height}
        _customColor={logoColor === 'custom' && customColor}
      />
    </Tooltip>
  );
}

export const LogoComponent = memo(LogoComponentInner);

const Image = styled.img`
  max-width: 100%;
  width: 100%;
  height: ${({ _height }) => (_height ? `${_height}px` : 'auto')};
  padding: 0;
  margin: 0;
  backface-visibility: hidden;
  max-height: 100%;
  object-fit: contain;

  ${({ _customColor }) =>
    _customColor && 'filter: grayscale(1) brightness(0) saturate(100%)'};
`;
